<template>
  <section v-if="activeProperty" class="row">
    <card>
      <div class="d-flex flex-wrap">
          <div class="col-12 mb-4">
            <div class="row">
              <div class="col-12">
                <h3>Editing {{ activeProperty.label }}</h3>
                <button class="btn btn-sm btn-primary" @click="viewAll">View all properties</button>
                <button class="btn btn-sm btn-primary ml-1" @click="saveProperty(activeProperty)">Save</button>
              </div>
            </div>
          </div>
          <div class="col-6 mb-4">
            <div class="row">
              <div class="col-6 mb-4">
                Label
                <input
                  type="text"
                  class="form-control form-control-lg"
                  v-model="activeProperty.label"
                  placeholder="i.e. apartment"
                />
              </div>
              <div class="col-6 mb-4">
                Status
                <select class="form-control" v-model="activeProperty.status">
                  <option value="Available">Available</option>
                  <option value="Builder Lots">Builder Lots</option>
                  <option value="Coming Soon">Coming Soon</option>
                  <option value="On Hold">On Hold</option>
                  <option value="Sold">Sold</option>
                  <option value="Not Released">Not Released</option>
                  <option value="Unassigned">Unassigned</option>
                </select>
              </div>
              <div class="col-6 mb-4">
                Price
                <input
                  type="text"
                  class="form-control"
                  :value="activeProperty.price"
                  @input="event => activeProperty.price = event.target.value.replace(/[^0-9.]/g, '')"
                />
              </div>
              <div class="col-6 mb-4">
                Frontage
                <input
                  type="number"
                  class="form-control"
                  step=".1"
                  v-model="activeProperty.frontage"
                />
              </div>
              <div class="col-6 mb-4">
                Depth
                <input
                  type="number"
                  class="form-control"
                  step=".1"
                  v-model="activeProperty.depth"
                />
              </div>
              <div class="col-6 mb-4">
                Size
                <input
                  type="number"
                  class="form-control"
                  step=".1"
                  v-model="activeProperty.size"
                />
              </div>
              <div class="col-12 mb-4">
                View/Outlook Label
                <input
                  class="form-control"
                  type="text"
                  v-model="activeProperty.viewLabel"
                />
              </div>

              <div class="col-12 mb-4">
                View/Outlook Images
                <input-asset
                  v-model="activeProperty.viewImages"
                  :multiple="true"
                />
              </div>

              <div class="col-12 mb-4">
                Is visible on webfeed?<br>
                <toggle-button 
                  v-model="activeProperty.isVisibleOnWebfeed" 
                  :color="{ checked: '#28a745', unchecked: '#b8b8b8' }"
                  :sync="true"
                  :width="30" 
                  :height="20"
                />
              </div>
            </div>
          </div>

          <div class="col-6 mb-4">
            <div class="row">
              <div class="col-12 mb-4">
                Available Dwellings
                <input-single-select
                  v-model="activeProperty.dwellingId"
                  label="Dwellings"
                  :options="dwellingOptions"
                />
              </div>
            </div>
          </div>
        </div>
    </card>
  </section>
</template>
<script>
import { mapGetters } from 'vuex'
import InputAsset from '@/components/InputAsset'
import InputMultiSelect from '@/components/InputMultiSelect'
import InputSingleSelect from '@/components/InputSingleSelect'

export default {
  components: { InputAsset, InputMultiSelect, InputSingleSelect },

  data () {
    return {
      activePropertyId: null,
      propertiesFilterText: '',
      filterStatuses: [],
      filterActiveStates: [],
    }
  },

  computed: {
    ...mapGetters([
      'properties',
      'dwellings'
    ]),

    activeProperty () {
      return this.properties.find(property => property._id === this.activePropertyId)
    },

    dwellingOptions () {
      return this.dwellings.map(dwelling => {
        return {
          label: dwelling.label,
          value: dwelling._id
        }
      })
    },
  },
  
  created () {
    this.$store.dispatch('FETCH_ASSETS')
    this.$store.dispatch('FETCH_PROPERTIES')
    this.$store.dispatch('FETCH_DWELLINGS')
  },

  mounted () {
    this.activePropertyId = this.$route.params.id
  },

  methods: {
    viewAll () {
      this.$router.push('/live/properties')
    },

    saveProperty (property) {
      this.$store.dispatch('SAVE_PROPERTY', property)
      this.viewAll()
    },
  },
}
</script>
